import { SidebarProvider } from "@/components/ui/sidebar";
import Header from "./Header";
import AdminSidebar from "./Sidebar";
import { LibraryContent } from "./library/LibraryContent";

const LibraryManagement = () => {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
        <AdminSidebar onSectionChange={() => {}} />
        <div className="flex flex-col flex-1 h-full">
          <Header />
          <main className="flex-1 p-2 sm:p-4 lg:p-6 overflow-auto dark:bg-[#020817] stable-gutter">
            <LibraryContent />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default LibraryManagement;